<div class="flex-direction-column height-100 page" [style]="isHml ? 'height: calc(-77px + 100vh)' : 'height: calc(-61px + 100vh)'">
  <div class="flex-direction-row justify-between align-center">
    <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" backgroundColor="transparent" classe="pesquisar"
                    widthFormField="325px" heightFormField="35px" borderColor="var(--primary)" (changeValue)="filtrarSetores($event)"></app-form-field>
  </div>

  @if (setores.length > 0 && !carregandoSetores) {
    <mat-table [dataSource]="dataSource" style="width: 98%; overflow: auto;">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5">
            <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="20px" heightIcon="20px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.id }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.ativo ? 'Ativo' : 'Inativo'}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.nome" class="ellipse">
            {{ elemento.nome }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <mat-header-cell *matHeaderCellDef> Descrição </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento.descricao" class="ellipse">
            {{ elemento?.descricao ? elemento.descricao : '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuCriacao">
        <mat-header-cell *matHeaderCellDef> Usuário Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento?.usuarioCriacao?.nome" class="ellipse">
             {{ elemento?.usuarioCriacao?.nome || '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef> Data Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ (elemento?.dataCriacao | date:'dd/MM/yyyy - HH:mm') || '-' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuAlteracao">
        <mat-header-cell *matHeaderCellDef> Usu. Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span [matTooltip]="elemento?.usuarioAlteracao?.nome" class="ellipse">
             {{ elemento?.usuarioAlteracao?.nome || '-' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef> Data Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ (elemento?.dataAlteracao | date:'dd/MM/yyyy - HH:mm') || '-' }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <app-paginator
      [length]="length"
      [pageSize]="limit"
      [pageIndex]="page"
      [width]="'calc(100% - 16px) !important'"
      (pageChange)="handlePageEvent($event)">
    </app-paginator>
  }
  @else if (setores.length <= 0 && !carregandoSetores){
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="">
    </div>
  }@else if(carregandoSetores){
    <app-tabela-skeleton [qntdLinhas]="5"></app-tabela-skeleton>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar setor" role="button" tabindex="0" (click)="abrirModal(false)" (keydown.enter)="abrirModal(false)" />
</div>
